import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './HowItWorks.css';

const HowItWorks = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const steps = [
    {
      icon: 'fas fa-pencil-alt',
      title: 'Journal Your Trade',
      description: 'Log your entry, exit, and thoughts using voice or text. Upload charts for visual context.'
    },
    {
      icon: 'fas fa-search-dollar',
      title: 'Get AI Analysis',
      description: 'Receive instant feedback on your chart technicals and trade execution from our AI engine.'
    },
    {
      icon: 'fas fa-lightbulb',
      title: 'Unlock Insights',
      description: 'Discover behavioral patterns like "fomo buying" or "revenge trading" to improve your psychology.'
    }
  ];

  return (
    <section id="how-it-works" className="how-it-works">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">How LunarLog AI Works</h2>
          <p className="section-subtitle">
            From simple logging to profound trading growth in three steps
          </p>
        </motion.div>
        
        <div ref={ref} className="steps">
          {steps.map((step, index) => (
            <motion.div 
              key={index}
              className="step"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.2 }}
            >
              <div className="step-icon">
                <i className={step.icon}></i>
              </div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
